import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {ApplicationScreenshot} from '../types';
import {Badge} from '@mantine/core';

const statusColor = (status?: string) => {
    switch (status) {
        case 'COMPLETED':
            return 'green';
        case 'PROCESSING':
            return 'blue';
        case 'PENDING':
            return 'yellow';
        case 'FAILED':
            return 'red';
        default:
            return 'gray';
    }
};

export const columns = [
    {
        title: I18n.get('URL'),
        width: '1fr',
        render: (item: ApplicationScreenshot) => <NavLink to={`/application-screenshots/${item.id}`}>{item.url}{item.path ? `/${item.path}` : ''}</NavLink>,
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: ApplicationScreenshot) => <Badge color={statusColor(item.status)}>{item.status}</Badge>,
    },
    {
        title: I18n.get('Viewport'),
        width: '1fr',
        render: (item: ApplicationScreenshot) => `${item.viewportWidth || 1920}x${item.viewportHeight || 1080}`,
    },
    {
        title: I18n.get('Full Page'),
        width: '1fr',
        render: (item: ApplicationScreenshot) => item.fullPage ? 'Yes' : 'No',
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: ApplicationScreenshot) => formatTimestamp(item.created as string),
    },
];
